// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3S4eC","approved":"Status_approved__3J3d8","rejected":"Status_rejected__W-TA1","expired":"Status_expired__1IM7C","label":"Status_label__1U4i1"};